import Utils from '@/common/utils/utils';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';

/**
 * On click popover footprint
 * @param {*} event
 * @param {*} itemData
 * @param {*} setFootPrintPopover
 * @param {*} knowledgeTicketList
 * @param {*} setUserFootprintList
 * @param {*} localFootPrint
 * @param {*} currentUserDetail
 */
export const onHoverPopoverFootprint = async (
    event,
    itemData,
    setFootPrintPopover,
    knowledgeTicketList,
    setUserFootprintList,
    localFootPrint = null,
    currentUserDetail = null
) => {
    let footPrint = localFootPrint || itemData?.footPrint;
    
    if(Utils.isEmptyArray(footPrint)){
        setFootPrintPopover(null);
        return;
    }
    setFootPrintPopover(event.currentTarget);

    let userDetailList = [];
    let index = knowledgeTicketList.findIndex((element, i) => {
        return element.id === itemData.id;
    });

    let footPrintDetail = Utils.convertJSONDataToObject(
        knowledgeTicketList[index]?.footPrintDetail
    );
    
    footPrint = Utils.convertJSONDataToObject(footPrint);

    let footPrintDetailMap = new Map();
    if (!Utils.isEmptyArray(footPrintDetail)) {
        footPrintDetail.forEach(userDetail => {
            footPrintDetailMap.set(userDetail.id, userDetail);
        });
    }

    let processedUsers = [];
    for (let userId of footPrint) {
        let userDetail = footPrintDetailMap.get(userId);
        
        if (!userDetail) {
            if (currentUserDetail && userId === currentUserDetail.id) {
                userDetail = currentUserDetail;
            }
        }

        if (userDetail) {
            processedUsers.push(userDetail);
        }
    }

    processedUsers.forEach(user => {
        let userName = Utils.getUserNameWithActiveStatus(user);
        
        if (!userName && user.mail) {
            userName = Utils.getDisplayUserEmailWithoutSuffix(user.mail);
        }
        
        if (userName) {
            if (!Utils.isEmptyObject(user.affiliationOrganizationInfo)) {
                let suffixUserName = Utils.getCorporationNameSuffixText(user.affiliationOrganizationInfo);
                if (suffixUserName) {
                    userName = `${userName} (${suffixUserName})`;
                }
            }

            userDetailList.push(
                <OverFlowTooltipWithTabsMui
                    key={`${itemData.id}_${user.id}`}
                    value={userName}
                    isFootPrintKnowledge={true}
                    avatar={user.avatar}
                    className={'footPrint-knowledge'}
                />
            );
        }
    });

    setUserFootprintList(userDetailList);
};


